import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Container, ProgressBar } from 'react-bootstrap'
import { App, Main, Root } from './Style'
import { Routes } from './RouteConfig'
import Header from '../Header'
import ProtectedRoute from '../ProtectedRoute'

const HomePage = lazy(() => import('../../Pages/HomePage'))
const LoginPage = lazy(() => import('../../Pages/LoginPage'))
const ApiPage = lazy(() => import('../../Pages/ApiPage'))
const ProjectsPage = lazy(() => import('../../Pages/ProjectsPage'))
const UsersManagementPage = lazy(() => import('../../Pages/UsersManagementPage'))
const EditProfilePage = lazy(() => import('../../Pages/EditProfilePage'))
const EditProfilePageClient = lazy(() => import('../../Pages/EditProfilePageClient'))
const ResetPassword = lazy(() => import('../../Pages/ResetPassword'))
const ForgotPassword = lazy(() => import('../../Pages/ForgotPassword'))
const AuditsPage = lazy(() => import('../../Pages/AuditsPage'))

const Layout: React.FC = () => {
  return (
    <Root>
      <App>
        <Header />
        <Container fluid>
          <Main>
            <Suspense fallback={<ProgressBar animated now={100} />}>
              <Switch>
                <Route exact path={Routes.homePage} component={HomePage} />
                <Route path={Routes.loginPage} component={() => <LoginPage />} />
                <Route path={Routes.resetPassword} component={ResetPassword} />
                <Route path={Routes.forgotPassword} component={ForgotPassword} />
                <ProtectedRoute
                  path={Routes.projectsPage}
                  component={() => <ProjectsPage />}
                  redirectTo={'/login'}
                />
                <ProtectedRoute path={Routes.api} component={ApiPage} redirectTo={'/login'} />
                <ProtectedRoute
                  path={Routes.users}
                  component={UsersManagementPage}
                  redirectTo={'/login'}
                />
                <ProtectedRoute
                  path={Routes.editProfile}
                  component={EditProfilePage}
                  redirectTo={'/login'}
                />
                <ProtectedRoute
                  path={Routes.editProfileClient}
                  component={EditProfilePageClient}
                  redirectTo={'/login'}
                />
                <ProtectedRoute path={Routes.audits} component={AuditsPage} redirectTo={'/login'} />
                <Redirect to={Routes.homePage} />
              </Switch>
            </Suspense>
          </Main>
        </Container>
      </App>
    </Root>
  )
}

export default Layout
